import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EmptyStateModule } from '../empty-state/empty-state.module';
import { AsyncUiComponent } from './async-ui.component';
import { SuccessDataDirective } from './success-data.directive';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [AsyncUiComponent, SuccessDataDirective],
  imports: [CommonModule, MatProgressSpinnerModule, EmptyStateModule, MatProgressBarModule],
  exports: [AsyncUiComponent, SuccessDataDirective],
})
export class AsyncUiModule {}
